<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><img alt="Image" height="16" src="images/top.jpg" width="500"/></p>
<h2 class="h2"><a id="page_9"></a><a id="foreword"></a><a class="nounder1" href="#/xhtml/contents"><span class="txbf">Foreword</span></a></h2>
<p class="imageb"><img alt="Image" height="18" src="images/bottom.jpg" width="500"/></p>
<p class="indent"> </p>
<p class="noindent">Did you ever stop to think that most of us spend the greater part of our lives on the job—whatever that job may be?</p>
<p class="indent">This means that our attitude toward our job can determine whether our days are filled with excitement and the sense of fulfillment that comes from top performance—or with frustration, boredom, and fatigue.</p>
<p class="indent">Dale Carnegie Training® is designed to help you get the most out of your working day in terms of job-satisfaction by getting the most out of yourself <span class="txit">all</span> the time. As you study these pages, evaluate your own approach to life and people. Then start to build on your strengths and discover how many talents and abilities you actually have that you didn’t even know you had—and how much fun it is to use these abilities.</p>
<p class="indent">This book is a collection of chapters selected from the revised editions of Dale Carnegie’s two best sellers, <span class="txit">How to Win Friends and Influence People</span> and <span class="txit">How to Stop Worrying and Start Living.</span> We have selected those portions of each book most relevant to people like yourself. You want more fulfillment in your life, a sense of harmony and purpose, a feeling that you’re making the best use of your inner resources—and this book will help you achieve these aims.</p>
<p class="indent">Participation in Dale Carnegie Training® is an adventure in self-discovery; and it could be a turning <a id="page_10">point in your life. You already possess hidden assets within yourself that can make your life glorious. All you need now is the determination to uncover and use them.</a></p><a id="page_10">
<p class="indent"> </p>
<p class="noindent">Dorothy Carnegie</p>
<p class="indent"> </p>
<p class="noindent">Chairman of the Board<br/>Dale Carnegie &amp; Associates, Inc.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?891c2100